export default __webpack_public_path__ + "static/media/logoRatifikaBN.25c79b4c.png";